export const defaultLocale = localStorage.getItem('defaultLocale') ? localStorage.getItem('defaultLocale') : 'pl'
export const languages = ['pl', 'en'];
